import { FormattedMessage } from 'react-intl';
import { Alert } from '@openedx/paragon';
import { Info } from '@openedx/paragon/icons';
import { SupportLink } from 'components/ui/atoms';
import { ErrorAlertProps } from './types';

/**
 * Paragon Alert component for order history error
 *
 * @param isVisible - whether to show alert or not
 * @returns Alert component
 */

export const ErrorAlert = ({ isVisible }: ErrorAlertProps) => {
  const alertTitle = (
    <FormattedMessage
      id="order.history.alert.title"
      defaultMessage="Something went wrong."
      description="order history alert title"
    />
  );

  const alertBody = (
    <FormattedMessage
      id="order.history.alert.body"
      defaultMessage="Refresh this page and try again. If this problem persists, {supportLink}."
      description="order history alert body"
      values={{ supportLink: <SupportLink /> }}
    />
  );

  return (
    <Alert className="mb-5" variant="danger" icon={Info} show={isVisible}>
      <h4>{alertTitle}</h4>
      <p>{alertBody}</p>
    </Alert>
  );
};
